const JWT_REGEX = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+$/

const getRequestInterceptorConfig = (getController, iframeRoutes) => {
    const targetPages = new Set([...(iframeRoutes || []), 'pages/error-404'])

    return {
        onFulfilled: config => {
            const authHeader = config.headers?.Authorization || config.headers?.authorization
            if (authHeader) {
                const token = String(authHeader).replace(/^Bearer\s+/i, '')
                if (!JWT_REGEX.test(token)) {
                    window.location.pathname = '/pages/error-404?pub=' // + GetPubAbbr();
                    // reject to stop the request
                    return Promise.reject(new Error('Invalid token format'))
                }
            }

            // Attach AbortController signal
            config.signal = getController().signal

            // Determine skipRedirectOn401 flag
            const { pathname, search } = window.location
            const page = pathname.replace(/^\/+/, '').split('/')[0]
            const params = new URLSearchParams(search)
            config.skipRedirectOn401 = targetPages.has(page) && params.has('token') && !params.has('advId')

            // 3) Log and validate headers by testing setRequestHeader
            if (config.headers) {
                Object.entries(config.headers).forEach(([name, value]) => {
                    try {
                        const testXhr = new XMLHttpRequest()
                        testXhr.open(config.method?.toUpperCase() || 'GET', config.url || '', true)
                        testXhr.setRequestHeader(name, String(value))
                    } catch (err) {
                        console.error(`❌ Invalid header detected →`, { name, value }, '\nError:', err.message)
                    }
                })
            }

            return config
        },
        onRejected: error => {
            return Promise.reject(error)
        }
    }
}

export default getRequestInterceptorConfig
